import { render, staticRenderFns } from "./BlogFael.vue?vue&type=template&id=52eb04bc&scoped=true&lang=pug&"
import script from "./BlogFael.vue?vue&type=script&lang=js&"
export * from "./BlogFael.vue?vue&type=script&lang=js&"
import style0 from "./BlogFael.styl?vue&type=style&index=0&id=52eb04bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb04bc",
  null
  
)

export default component.exports